export default __webpack_public_path__ + "static/media/propiedad.5877552e.jpg";